import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import special from "../../Assets/bgs/special-offer.png";

const Style = styled.div`
    display: grid;
    position: relative;
    grid-template-columns: calc(70px - 1rem) repeat(8, calc(calc(calc(100% - calc(140px)) / 8) - calc(7rem / 8)))  calc(70px - 1rem);
    grid-gap: 1rem;
    grid-template-rows: 0rem 70px calc(calc(100% - 70px) - 3rem) 0rem;
    .data-1 {
        grid-column: 2/8;
        grid-row: 2/4;
        background-color: blue;
        border-radius: 1rem;
        padding: 1rem;
        position: relative;
        overflow: hidden;
        animation: fade-in-anim1 0.6s ease-in-out 1 0s forwards;
        .info {
            .logo {
                position: absolute;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                max-width: 180px;
                padding: 5px 10px;
                background-color: #fff;
                border-radius: 4px;
                margin: 0 0 1.5rem;
                img {
                    width: 100%;
                }
            }
            .desc {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }
    .data-2 {
        grid-column: 8/10;
        grid-row: 3/4;
        background-color: blue;
        border-radius: 1rem;
        padding: 1rem;
        position: relative;
        overflow: hidden;
        opacity: 0;
        animation: fade-in-anim1 0.6s ease-in-out 1 0.15s forwards;
    }
    .data-ads {
        grid-column: 8/10;
        grid-row: 2/3;
        background-color: var(--prime-2);
        color: #fff;
        border-radius: 1rem;
        padding: 1rem;
        position: relative;
        overflow: hidden;
        opacity: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.5rem;
        text-decoration: none;
        box-shadow: 0 0 0 0 var(--prime-2-o);
        transition: all 0.2s ease-in-out;
        animation: fade-in-anim-inf 0.6s linear infinite 0.15s;
        position: relative;
        &.rtl {
            .offer-img {
                right: auto;
                left: 0;
            }
        }
        :hover {
            box-shadow: 5px 5px 0px 0px var(--prime-2-o);
        }
        .title {
            font-size: 1.2rem;
            font-weight: 600;
        }
        .desc {
            font-size: 0.9rem;
            width: calc(100% - 100px);
        }
        .offer-img {
            position: absolute;
            width: 70px;
            bottom: 0;
            right: 0;
        }
    }
    .data-3 {
        grid-column: 8/10;
        grid-row: 3/4;
        background-color: blue;
        border-radius: 1rem;
        padding: 1rem;
        position: relative;
        overflow: hidden;
        opacity: 0;
        animation: fade-in-anim1 0.6s ease-in-out 1 0.3s forwards;
    }
    .bg-img {
        position: absolute;
        inset: 0;
        z-index: 0;
        img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
        video {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }
        .overlay {
            position: absolute;
            inset: 0;
            background-color: #000000;
            opacity: 0.5;
        }
    }
    .more-btn {
        text-decoration: none;
        z-index: 2;
        position: absolute;
        bottom: 0.5rem;
        right: 0.5rem;
        background-color: var(--prime-2);
        color: #fff;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        border-radius: 0.5rem;
        padding: 0.2rem 0.2rem 0.25rem 0.2rem;
        gap: 0.3rem;
        max-width: calc(24px);
        transition: all 0.2s ease-in-out;
        overflow: hidden;
        cursor: pointer;
        .text {
            /* padding: 0.2rem 0 0; */
        }
        .icon {
            width: 24px;
            height: 24px;
            svg {
                fill: #fff;
                rotate: -90deg;
                display: block;
            }
        }
        &:hover{
            padding: 0.2rem 0.2rem 0.25rem 0.9rem;
            max-width: 3.9rem;
        }
    }
    .info {
        position: relative;
        z-index: 1;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        width: 50%;
        padding-left: 7%;
        padding-right: 7%;
        .logo {
            max-width: 120px;
            padding: 0 10px;
            background-color: #fff;
            border-radius: 4px;
            margin: 0 0 1.5rem;
            img {
                width: 100%;
            }
        }
        .title {
            font-size: 2rem;
            font-weight: 800;
            color: #fff;
            position: relative;
            opacity: 0;
            animation: fade-in-anim2 0.8s ease-in-out 1 0.3s forwards;
        }
        .desc {
            margin: 0.5rem 0;
            font-size: 1rem;
            color: #fff;
            position: relative;
            opacity: 0;
            animation: fade-in-anim2 0.8s ease-in-out 1 0.45s forwards;
        }
        .links {
            margin: 0.5rem 0;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            font-size: 0.9rem;
            &.rtl {
                .link {
                    svg {
                        transform: rotate(90deg);
                        left: auto;
                        right: 0;
                    }
                    .text {
                        left: auto;
                        right: 0;
                    }
                    :hover {
                        svg {
                            right: -0.5rem;
                        }
                        .text {
                            right: -0.25rem;
                        }
                    }
                }
            }
            .link {
                color: #fff;
                text-decoration: none;
                display: flex;
                align-items: center;
                transition: all 0.2s ease-in-out;
                :hover {
                    svg {
                        left: -0.5rem;
                    }
                    .text {
                        left: -0.25rem;
                    }
                }
                svg {
                    fill: #fff;
                    transform: rotate(-90deg);
                    position: relative;
                    left: 0;
                    width: 18px;
                    transition: all 0.2s ease-in-out;
                }
                .text {
                    position: relative;
                    left: 0;
                    width: calc(100% - 18px);
                    transition: all 0.2s ease-in-out;
                }
            }
        }
        .ctas {
            margin: 0.5rem 0;
            display: flex;
            gap: 12px;
            position: relative;
            opacity: 0;
            animation: fade-in-anim2 0.8s ease-in-out 1 0.6s forwards;
            .cta {
                cursor: pointer;
                flex-grow: 1;
                border: 1px solid #fff;
                border-radius: 8px;
                font-size: 1.2rem;
                font-weight: 600;
                text-align: center;
                padding: 0.75rem 0;
                color: #fff;
                text-decoration: none;
                &.cta-btn-1 {
                    border: 1px solid var(--prime-2);
                    :hover {
                        background-color: #00000020;
                    }
                }
                &.cta-btn-2 {
                    background-color: var(--prime-2);
                    border: 1px solid var(--prime-2);
                    color: #fff;
                    :hover {
                        background-color: var(--prime-2);
                    }
                }
            }
        }
    }
    .data-2, .data-3 {
        .info {
            height: 100%;
            width: 100%;
            justify-content: flex-start;
            padding-left: 0;
            padding-right: 0;
            .title {
                font-size: 1.5rem;
            }
        }
    }
    @keyframes fade-in-anim-inf {
        0% {
            box-shadow: 0 0 0 0 var(--prime-2-o);
        }
        70%  {
            box-shadow: 0 0 0 7px var(--prime-2-o);
        }
        100%  {
            box-shadow: 0 0 0 10px #f7842700;
        }
    }
    @keyframes fade-in-anim1 {
        0% {
            opacity: 0;
            top: 6rem
        }
        100%  {
            opacity: 1;
            top: 0;
        }
    }
    @keyframes fade-in-anim2 {
        0% {
            opacity: 0;
            top: 6rem
        }
        50% {
            opacity: 0;
        }
        100%  {
            opacity: 1;
            top: 0;
        }
    }
    @media (max-width: 850px){
        grid-template-columns: 0 repeat(8, calc(calc(calc(100% - 2rem) / 8) - calc(7rem / 8))) 0;
        grid-template-rows: 0rem repeat(5, calc(calc(100% - 9rem) / 9)) 70px repeat(3, calc(calc(100% - 9rem) / 9)) 0rem;
        .data-1 {
            grid-column: 2/10;
            grid-row: 2/7;
            .info {
                height: 100%;
                width: 100%;
                justify-content: flex-end;
                padding-left: 0;
                .title {
                    font-size: 2.2rem;
                }
            }
        }
        .data-ads {
            grid-column: 2/10;
            grid-row: 7/8;
            .offer-img {
                position: absolute;
                width: 70px;
            }
        }
        .data-2 {
            grid-column: 2/10;
            grid-row: 8/11;
            .info {
                .title {
                    font-size: 1.2rem;
                }
                .desc {
                    font-size: 0.9rem;
                    display: none;
                }
            }
        }
        .data-3 {
            grid-column: 6/10;
            grid-row: 5/6;
            .info {
                .title {
                    font-size: 1.2rem;
                }
                .desc {
                    font-size: 0.9rem;
                    display: none;
                }
            }
        }
        .more-btn {
            padding: 0.2rem 0.2rem 0.25rem 0.9rem;
            max-width: 3.9rem;
        }
    }

`;

export default function Twoparthome2({pageHeight, data, language}) {
    const scrollOneScreen = () => {
        window.scrollTo({
            top: pageHeight - 60,
            behavior: "smooth"
        })
    }
    const makeCta = (cta) => {
        switch(cta.type){
            case "scroll":
                return (
                    <div className={"cta cta-btn-1 " + cta.class} onClick={scrollOneScreen}>
                        {cta.title}
                    </div>
                )
            case "link":
                return (
                    <a href={cta.route} target={cta.target} className={"cta " + cta.class}>
                        {cta.title}
                    </a>
                )
            case "link-inside":
                return (
                    <Link to={cta.route} target={cta.target} className={"cta " + cta.class}>
                        {cta.title}
                    </Link>
                )
            default:
                return;
        }
    }
    const makeLinks = (links = []) => {
        let htmlLinks = links.map((v, i) => {
            switch(v.type){
                case "link":
                    return (
                        <a href={v.route} target={v.target} className="link" key={i}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M3.54975 8.41967C3.84264 8.12677 4.31752 8.12677 4.61041 8.41967L11.1304 14.9397C11.6075 15.4168 12.3926 15.4168 12.8697 14.9397L19.3897 8.41967C19.6826 8.12677 20.1575 8.12677 20.4504 8.41967C20.7433 8.71256 20.7433 9.18743 20.4504 9.48033L13.9304 16.0003C12.8675 17.0632 11.1326 17.0632 10.0697 16.0003L3.54975 9.48033C3.25685 9.18743 3.25685 8.71256 3.54975 8.41967Z"/>
                            </svg>
                            <div className="text">{v.title}</div>
                        </a>
                    )
                case "link-inside":
                    return (
                        <Link to={v.route} target={v.target} className="link" key={i}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M3.54975 8.41967C3.84264 8.12677 4.31752 8.12677 4.61041 8.41967L11.1304 14.9397C11.6075 15.4168 12.3926 15.4168 12.8697 14.9397L19.3897 8.41967C19.6826 8.12677 20.1575 8.12677 20.4504 8.41967C20.7433 8.71256 20.7433 9.18743 20.4504 9.48033L13.9304 16.0003C12.8675 17.0632 11.1326 17.0632 10.0697 16.0003L3.54975 9.48033C3.25685 9.18743 3.25685 8.71256 3.54975 8.41967Z"/>
                            </svg>
                            <div className="text">{v.title}</div>
                        </Link>
                    )
                default:
                    return;
            }
        })
        return (
            <div className={"links " + (language.dir)}>
                {htmlLinks}
            </div>
        )
    }
    const makeDesc = (desc) => {
        if(typeof desc === "string"){
            return desc
        }
        return desc.map((v, i) => {
            return (
                <div key={i}>{v}</div>
            )
        })
    }
    let splitImage1 = data.data["1"].bgimage.split(".");
    let format1 = splitImage1[splitImage1.length - 1];
    let type1 = "image"
    if(format1 === "mp4"){
        type1 = "video"
    }
    return (
      <Style style={{height: `${(pageHeight - 90)*((window.innerWidth < 800) ? 1.65 : 1)}px`}}>
        <div className="data-1">
            <div className="bg-img">
                {
                    (type1 === "image") ? (
                        <img src={data.data["1"].bgimage}/>
                    ) : (
                        <video autoPlay loop muted playsInline>
                            <source src={data.data["1"].bgimage} type="video/mp4" />
                        </video>
                    )
                }
                
                <div className="overlay"></div>
            </div>
            <div className="info">
                <div className="title">
                    {data.data["1"].title}
                </div>
                <div className="desc">
                    {makeDesc(data.data["1"].desc)}
                </div>
                <div className="ctas">
                    {
                        (data.data["1"].cta1) ? (
                            makeCta(data.data["1"].cta1)
                        ) : ""
                    }
                    {
                        (data.data["1"].cta2) ? (
                            makeCta(data.data["1"].cta2)
                        ) : ""
                    }
                </div>
            </div>
        </div>
        {
            (data.ads) ? (
                <Link to={data.ads.cta.route} className={"data-ads " + language.dir}>
                    <div className="title">
                        {data.ads.title}
                    </div>
                    {/* <div className="desc">
                        {data.ads.desc}
                    </div> */}
                    <img className="offer-img" src={special} alt="offer"/>
                </Link>
            ) : ""
        }
        
        <div className="data-2">
            <div className="bg-img">
                <img src={data.data["2"].bgimage}/>
                <div className="overlay"></div>
            </div>
            <div className="info">
                {
                    (data.data["2"].logoImage) ? (
                        <div className="logo">
                            <img src={data.data["2"].logoImage} alt={data.data["2"].title}/>
                        </div>
                    ) : ""
                }
                
                <div className="title" style={{animationDelay: "0.45s"}}>
                    {data.data["2"].title}
                </div>
                <div className="desc" style={{animationDelay: "0.6s"}}>
                    {data.data["2"].desc}
                </div>
                {makeLinks(data.data["2"].links)}
            </div>
            {/* <a href={data.data["2"].cta1.route} className="more-btn">
                <div className="text">
                    More
                </div>
                <div className="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M3.54975 8.41967C3.84264 8.12677 4.31752 8.12677 4.61041 8.41967L11.1304 14.9397C11.6075 15.4168 12.3926 15.4168 12.8697 14.9397L19.3897 8.41967C19.6826 8.12677 20.1575 8.12677 20.4504 8.41967C20.7433 8.71256 20.7433 9.18743 20.4504 9.48033L13.9304 16.0003C12.8675 17.0632 11.1326 17.0632 10.0697 16.0003L3.54975 9.48033C3.25685 9.18743 3.25685 8.71256 3.54975 8.41967Z"/>
                    </svg>
                </div>
            </a> */}
        </div>
      </Style>
  );
}
